var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgOnHandInventory = function SvgOnHandInventory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    "data-name": "On Hand Inventory",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.568 19.36h9.581a.578.578 0 0 0 .568-.585V8.619a.578.578 0 0 0-.568-.585h-1.334v-.366a.871.871 0 0 0-.868-.872h-1.013a1.617 1.617 0 0 0-3.151 0H6.77a.871.871 0 0 0-.868.872v.366H4.568A.578.578 0 0 0 4 8.619v10.156a.578.578 0 0 0 .568.585zM6.593 7.668a.171.171 0 0 1 .177-.16h1.2a.474.474 0 0 0 .473-.435.926.926 0 0 1 1.84 0 .474.474 0 0 0 .473.435h1.2a.171.171 0 0 1 .177.16v.366h-.013v.882a.189.189 0 0 1-.186.178H6.792a.189.189 0 0 1-.186-.178v-.882h-.013zM4.691 8.741H5.9v.2a.871.871 0 0 0 .868.872h5.178a.871.871 0 0 0 .868-.872v-.2h1.21v9.9H4.691z",
    "data-name": "Path 11520"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.662 11.718h-6.57c-.184 0-.333.111-.333.249s.149.249.333.249h6.57c.184 0 .333-.111.333-.249s-.146-.249-.333-.249z",
    "data-name": "Path 11523"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.662 13.958h-6.57c-.184 0-.333.111-.333.249s.149.249.333.249h6.57c.184 0 .333-.111.333-.249s-.146-.249-.333-.249z",
    "data-name": "Path 11586"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M12.662 16.197h-6.57c-.184 0-.333.111-.333.249s.149.249.333.249h6.57c.184 0 .333-.111.333-.249s-.146-.249-.333-.249z",
    "data-name": "Path 11587"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19 9.081h-2.445a1.719 1.719 0 0 0-.363-.865h1.963a.162.162 0 0 0 .16-.163V3.02a.162.162 0 0 0-.16-.16l-1.867.006a.165.165 0 0 0-.166.16v2.336l-.725-.615a.156.156 0 0 0-.105-.04.142.142 0 0 0-.1.04l-.73.615V3.026a.164.164 0 0 0-.164-.16l-1.73-.006a.16.16 0 0 0-.162.16V5.5a2.071 2.071 0 0 0-.687-.129v-3.37h7.283V9.08z",
    "data-name": "Path 11608"
  })));
};
export default SvgOnHandInventory;